<template>
  <div class="global-footer-copy-notification-block">
    <p class="global-footer-copy-notification">掲載の情報・画像など、すべてのコンテンツの無断複写、転載を禁じます。</p>
  </div>
</template>

<script>
export default {
  name: 'copyright-notification',
};
</script>
